export default __webpack_public_path__ + "static/media/pve4.e2f16374.jpg";